<template>
  <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="编辑设计版" :visible.sync="isShow" width="800px">
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="id" label="编号"></el-table-column>
      <el-table-column prop="date" label="模板缩略图">
        <template slot-scope="scope">
          <templateThumbnail :ref="'templateThumbnail'+scope.$index" :templateGroup="scope.row" />
        </template>
      </el-table-column>
      <el-table-column prop="date" label="页面类型">
        <template slot-scope="scope">
          {{$config.pageType[scope.row.pageTypeCode]}}
        </template>
      </el-table-column>
      <el-table-column prop="imageCount" label="照片数量"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span class="color-blue" @click="$refs['templateThumbnail'+scope.$index].checkImg()">查看<br></span>
          <span class="color-blue" v-show="scope.row.defaultModule===0" @click="setDefault(scope.row.xrefId)">设为默认<br></span>
          <span v-show="scope.row.defaultModule===1">默认<br></span>
          <span class="color-blue" @click="tableData.splice(scope.$index,1)">移除</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="edit()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import templateThumbnail from '@/components/templateThumbnail.vue'
import { getTemplateGroupByModuleId, templateGroupRelation, templateGroupSetDefaultModule } from '@/api/pms.js'
export default {
  components: {
    templateThumbnail
  },
  data () {
    return {
      isShow: false,
      moduleId: '',
      tableData: []
    }
  },
  methods: {
    setDefault (id) {
      templateGroupSetDefaultModule(id)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置成功')
            this.getTemps()
          }
        })
    },
    edit () {
      let val = {
        moduleId: this.moduleId,
        templateGroupIds: []
      }

      this.tableData.forEach(item => {
        val.templateGroupIds.push(item.id)
      })

      templateGroupRelation(val)
        .then(res => {
          if (res.data.success) {
            this.$message.success('编辑成功')
            this.isShow = false
          }
        })
    },
    show (id) {
      this.moduleId = id
      this.isShow = true
      this.getTemps()
    },
    getTemps () {
      getTemplateGroupByModuleId(this.moduleId)
        .then(res => {
          console.log(res)
          if (res.data.success) {
            let list = res.data.data

            list.forEach(item => {
              if (item.propertyId === 2) {
                item.templateThumbnailList = [item.templates[0].templateThumbnail]
              } else {
                item.templateThumbnailList = item.templates.reduce((list, temp) => {
                  list[temp.templatePosition] = temp.templateThumbnail
                  return list
                }, [])
              }
            })

            this.tableData = list
            console.log(list)
          }
        })
    }
  }
}
</script>

<style lang='less'>
.imgBox {
  width: 100%;
  display: flex;
  justify-content: space-around;
  .img {
    flex: 1;
  }
}
</style>
